import { Box, SkeletonGroup, SkeletonRectangle } from '@wix/design-system';
import React, { useState } from 'react';
import { SearchRecommendationModule } from './SearchRecommendation.module';
import s from './SearchRecommendation.module.scss';
const SKELETON_DATA_HOOKS = {
  row: 'skeleton-row',
  rowActive: 'skeleton-row-active',
  divider: 'skeleton-divider',
  dividerHidden: 'skeleton-divider-hidden'
};
const DesktopSkeleton = _ref => {
  let {
    optimized = false
  } = _ref;
  const {
    SearchRecommendationSkeletonContainer,
    ActionsContainer,
    PricingWrapper,
    LabelContainer,
    DomainInfoContainer
  } = SearchRecommendationModule.SDK.Layouts;
  return /*#__PURE__*/React.createElement(SearchRecommendationSkeletonContainer, null, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    align: "left",
    gap: "SP3",
    alignSelf: "start"
  }, /*#__PURE__*/React.createElement(DomainInfoContainer, null, !optimized && /*#__PURE__*/React.createElement(LabelContainer, {
    premium: false,
    domain: "",
    visible: true
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "82px",
    height: "20px"
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    verticalAlign: "middle",
    gap: "SP3"
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "212px",
    height: "24px"
  })))), /*#__PURE__*/React.createElement(ActionsContainer, null, /*#__PURE__*/React.createElement(PricingWrapper, {
    direction: "vertical",
    gap: "SP1",
    align: "right"
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "115px",
    height: "16px"
  }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "138px",
    height: "16px"
  })), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeletonButton,
    width: "78px",
    height: "38px"
  })));
};
const MobileSkeleton = _ref2 => {
  let {
    optimized = false
  } = _ref2;
  if (optimized) {
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      padding: "16px",
      gap: "16px"
    }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
      className: s.skeleton,
      width: "209px",
      height: "30px"
    }), /*#__PURE__*/React.createElement(Box, {
      direction: "horizontal",
      placeItems: "center",
      placeContent: "space-between"
    }, /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      gap: "4px"
    }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
      className: s.skeleton,
      width: "139px",
      height: "20px"
    }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
      className: s.skeleton,
      width: "139px",
      height: "20px"
    })), /*#__PURE__*/React.createElement(SkeletonRectangle, {
      className: s.skeletonButton,
      width: "91",
      height: "46px"
    })));
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    padding: "16px",
    gap: "16px"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "24px"
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "92px",
    height: "24px"
  }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "209px",
    height: "30px"
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "4px"
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "139px",
    height: "20px"
  }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "139px",
    height: "20px"
  })), /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    placeItems: "center",
    placeContent: "space-between"
  }, /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeleton,
    width: "131px",
    height: "24px"
  }), /*#__PURE__*/React.createElement(SkeletonRectangle, {
    className: s.skeletonButton,
    width: "91",
    height: "46px"
  })));
};
export const SearchRecommendationSkeleton = _ref3 => {
  let {
    onMouseEnter,
    useMobileLayout = false,
    optimized = false
  } = _ref3;
  return /*#__PURE__*/React.createElement(SkeletonGroup, {
    skin: "light",
    className: s.skeletonGroup
  }, /*#__PURE__*/React.createElement("div", {
    onMouseEnter: onMouseEnter
  }, useMobileLayout ? /*#__PURE__*/React.createElement(MobileSkeleton, {
    optimized: optimized
  }) : /*#__PURE__*/React.createElement(DesktopSkeleton, {
    optimized: optimized
  })));
};
export const SearchRecommendationListSkeleton = _ref4 => {
  let {
    limit = 10,
    useMobileLayout = false,
    defaultNonHovered = false,
    optimized = false
  } = _ref4;
  const {
    SearchRecommendationListContainer,
    Divider,
    HoverBox
  } = SearchRecommendationModule.SDK.Layouts;
  const [hoveredIndex, setHoveredIndex] = useState(defaultNonHovered ? -1 : 0);
  return /*#__PURE__*/React.createElement(Box, {
    width: "100%",
    flex: 1
  }, /*#__PURE__*/React.createElement(SearchRecommendationListContainer, {
    className: s.searchRecommendationList
  }, Array.from({
    length: limit
  }).map((_, index) => {
    const isActive = index === hoveredIndex;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: index
    }, /*#__PURE__*/React.createElement(HoverBox, {
      key: index,
      display: "block",
      className: `${s.searchRecommendation} ${isActive ? s.hovered : ''}`,
      dataHook: isActive ? SKELETON_DATA_HOOKS.rowActive : SKELETON_DATA_HOOKS.row
    }, /*#__PURE__*/React.createElement(SearchRecommendationSkeleton, {
      onMouseEnter: () => setHoveredIndex(index),
      useMobileLayout: useMobileLayout,
      optimized: optimized
    })), index !== limit - 1 && (useMobileLayout ? /*#__PURE__*/React.createElement(Box, {
      marginTop: "20px",
      marginBottom: "20px"
    }, /*#__PURE__*/React.createElement(Divider, {
      dataHook: isActive ? SKELETON_DATA_HOOKS.dividerHidden : SKELETON_DATA_HOOKS.divider
    })) : /*#__PURE__*/React.createElement(Divider, {
      dataHook: isActive ? SKELETON_DATA_HOOKS.dividerHidden : SKELETON_DATA_HOOKS.divider
    })));
  })));
};
//# sourceMappingURL=SearchRecommendationSkeleton.js.map